import jwt_decode from 'jwt-decode';
import store from '../../../store';
import { setParseTpToken, setParseAADToken, removeAccess, signOutUser } from '../../../api/reducers/authReducer';
import Config from './Config';
import uuidv4 from 'uuid/v4';
import momentTime from 'moment';
import Debug from './Debug';
import CryptoJS from 'crypto-js';
import * as Cookies from 'js-cookie';

window.__CryptoJS = CryptoJS;

let _session = store.getState().auth.user;

const storeDispatch = (func) => {
  return store.dispatch(func);
};

let Session = {
  getTpToken: () => {
    let tpInfo = store.getState().auth.user.tpInfo;
    return tpInfo && tpInfo.token ? tpInfo.token : '';
  },
  get: (key) => {
    // check if token is present and exp time is greater than current time. Remove if it is expired.
    //Only do this if config is loaded.
    if (!_session.tpInfo || !_session.tpInfo.tenant) {
      _session = store.getState().auth.user;
    }
    if (Session.getTpToken() && !Config.get('demo') && Config.get('assetsURL')) {
      Session.removeTokenIfExpired();
    }
    let aid = Session.getTpToken();
    if (aid && aid !== _session.token) {
      // Refresh the _session
      _session = store.getState().auth.user;
      if (aid !== _session.token) {
        // Ensure cookie updates are processed
        storeDispatch(setParseTpToken(aid));
      }
    }
    switch (key) {
      case 'isOneCloudLogin':
        return sessionStorage.getItem('loginType') === 'onecloud' || Session.get('onecloud_token');
      default:
        return key ? _session.tpInfo[key] : _session;
    }
  },
  getToken: () => {
    let encryptedDuiToken = localStorage.getItem('dui_token_e');
    window.__CryptoJS = CryptoJS;
    if (encryptedDuiToken) {
      try {
        let decryptedDuiToken = CryptoJS.AES.decrypt(encryptedDuiToken, '5XBoZ7li2W5wzhOULEqtQzdkufjsVFs4');
        let decToken = decryptedDuiToken.toString(CryptoJS.enc.Utf8);
        return decToken;
      } catch (e) {
        Debug.log('GetToken - Error decoding token: ' + e);
      }
    } else if (localStorage.getItem('dui_token')) {
      Debug.log('GetToken - No encryptedDuiToken');
    }
  },
  setToken: (token) => {
    Cookies.set('dui_encryptionKey', '5XBoZ7li2W5wzhOULEqtQzdkufjsVFs4');
    let encryptedToken = CryptoJS.AES.encrypt(token, '5XBoZ7li2W5wzhOULEqtQzdkufjsVFs4').toString();
    localStorage.setItem('dui_token_e', encryptedToken);
    storeDispatch(setParseTpToken(token));
  },
  setTpToken: (token) => {
    token = token || Session.getToken();
    if (token) {
      Cookies.set('dui_encryptionKey', '5XBoZ7li2W5wzhOULEqtQzdkufjsVFs4');
      let encryptedToken = CryptoJS.AES.encrypt(token, '5XBoZ7li2W5wzhOULEqtQzdkufjsVFs4').toString();
      localStorage.setItem('dui_token_e', encryptedToken);
      storeDispatch(setParseTpToken(token));
    }
  },
  setAADToken: (token = '') => {
    token = token || localStorage.getItem('adminx__token');
    if (token) {
      localStorage.setItem('adminx__token', token);
      storeDispatch(setParseAADToken(token));
    }
  },
  removeTokenIfExpired: () => {
    let tokens = ['dui_token_e', 'adminx__token'];
    let removeIfExpired = (token_key) => {
      let storedToken = token_key == 'dui_token_e' ? Session.getToken() : localStorage.getItem(token_key);
      if (!storedToken) {
        return;
      }
      try {
        let decodedStoredToken = jwt_decode(storedToken);
        let expTime = decodedStoredToken.exp * 1000;
        let currentTime = momentTime.utc().valueOf();
        if (currentTime > expTime && !Config.get('demo')) {
          Session.removeToken(token_key);
          switch (token_key) {
            case 'dui_token_e':
              storeDispatch(removeAccess({ canAccessTechPulse: false }));
              break;
            case 'adminx__token':
              storeDispatch(removeAccess({ canAccessAdminx: false }));
              break;
            default:
              break;
          }
          Debug.log('Expired JWT token removed');
          storeDispatch(signOutUser({}));
        }
      } catch (e) {
        Debug.log('Failed to parse JWT token');
        Session.removeToken(token_key);
        storeDispatch(signOutUser({}));
      }
    };
    for (let key of tokens) {
      removeIfExpired(key);
    }
  },
  removeToken: (token_key) => {
    if (token_key) {
      token_key == 'dui_token_e' && Session.removeSessionId();
      localStorage.removeItem(token_key);
    } else {
      Session.removeToken('dui_token_e');
      Session.removeToken('adminx__token');
    }
  },
  removeSessionId: () => {
    localStorage.removeItem('daas_session_id');
  },
  generateSessionId: () => {
    if (!localStorage.getItem('daas_session_id')) {
      localStorage.setItem('daas_session_id', uuidv4());
    }
  },
  getJWTTokenForOrgLess: () => {
    return localStorage.getItem('dui_org_less_token') || '';
  },
  getIsAADLoggedInUserOC: () => {
    try {
      let token = Session.getToken();
      if (!token) {
        token = Session.getJWTTokenForOrgLess();
      }
      if (token) {
        let decoded_token = jwt_decode(token);
        if (decoded_token.idp_type === 'azure') {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (e) {
      Debug.log('Exception in getIsAADLoggedInUserOC' + e);
      return false;
    }
  },
};
export default Session;
